<app-toasts #toastDrag aria-live="polite" aria-atomic="true"></app-toasts>
<div class="drag-drop-container">
    <div *ngIf="loading.load" class="mt-25-perc">
        <div class="progress progress-indeterminate">
            <div class="progress-bar" style="background-color: #06c" role="progressbar"></div>
        </div>
        <p style="text-align: center; margin-top:20px;">{{loading.message}}</p>
    </div>
    <div *ngIf="!loading.load">
        <mat-accordion [multi]="true" cdkDropListGroup cdkDropList [cdkDropListData]="items"
            (cdkDropListDropped)="dropItem($event)">
            <div *cdkDragPlaceholder></div>

            <!-- Iterazione per ogni item -->
            <ng-container *ngFor="let item of items; let i = index">
                <mat-expansion-panel [disabled]="!item.below || item.below.length === 0" *ngIf="item" class="item-panel"
                    [expanded]="false" cdkDrag [cdkDragDisabled]="items.length <= 1" [cdkDragData]="item">
                    <mat-expansion-panel-header>
                        <mat-panel-title class="item-title">
                            <!-- Manico del drag solo se cdkDragDisabled è false -->
                            <ng-container *ngIf="!(items.length <= 1)">
                                <i class="fa fa-arrows-alt cursor-move" cdkDragHandle></i> <!-- Icona di drag -->
                            </ng-container>
                            {{ item.title }}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <!-- Gestione ricorsiva dei figli -->
                    <div *ngIf="item.below && item.below.length > 0" cdkDropList [cdkDropListData]="item.below"
                        [cdkDropListConnectedTo]="idList" class="item-list" (cdkDropListDropped)="dropItem($event)">
                        <div *ngFor="let subItem of item.below" class="item-box" cdkDrag [cdkDragData]="subItem">
                            <p class="item-title">
                                <!-- Manico del drag solo se cdkDragDisabled è false -->
                                <ng-container *ngIf="!(item.below.length <= 1)">
                                    <i class="fa fa-arrows-alt cursor-move" cdkDragHandle></i> <!-- Icona di drag -->
                                </ng-container>
                                {{ subItem.title }}
                            </p>

                            <!-- Ricorsione per i figli di 'subItem' -->
                            <div *ngIf="subItem.below && subItem.below.length > 0">
                                <app-drag-drop [items]="subItem.below" [depth]="depth + 1"></app-drag-drop>
                            </div>
                        </div>
                    </div>
                </mat-expansion-panel>
            </ng-container>
        </mat-accordion>

        <!-- Mostra i pulsanti solo se siamo alla profondità 0 -->
        <div *ngIf="depth === 0" class="d-flex justify-content-between mt-3">
            <button class="btn btn-danger m-20-btn" (click)="reset()">Reset</button>
            <button class="btn btn-primary m-20-btn" (click)="save()">Salva</button>
        </div>
    </div>
</div>